<div id="main">
    <h1>Infos</h1>
    <p>You can add text here</p>
    <p>Once on the 'Application page' click on an event in the table to begin the query</p>
    <p>To find the stations related to this event, you need (at least) the radius (in degrees)</p>

    <p>Finally you can click on the station, or enter the name in the input to request the data (if you do not choose at least one station, the request will take all the displayed stations</p>
    <p>Data from 'name' <br/> Created by Lucie Rolland <br/> Application Created by Arthur Fontaine</p>
</div>
